import { render, staticRenderFns } from "./BaseDataSelect.vue?vue&type=template&id=f2b00498&"
import script from "./BaseDataSelect.vue?vue&type=script&lang=js&"
export * from "./BaseDataSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports